import { IconAndTextItemType } from "@/components/dropdown/items.type";
import { ref } from "@vue/composition-api";
import { PopulationTypeHelper, POPULATION_TYPE } from "../models";

export const UseEntitiesDropDown = (payload: {
  entities: POPULATION_TYPE[];
  onChange: (item: IconAndTextItemType) => void;
  all: boolean;
}) => {
  const { all = false, entities, onChange } = payload;

  const entitiesType = PopulationTypeHelper.displayList(entities, true).map(
    (item) => {
      return {
        ...item,
        name: item.name + "s",
        type: "iconAndText",
        checked: false,
        disable: item.id == POPULATION_TYPE.FILE,
      } as IconAndTextItemType;
    }
  );

  if (all) {
    entitiesType.unshift({
      type: "iconAndText",
      id: POPULATION_TYPE.ALL,
      icon: "All",
      name: "All",
      checked: true,
    });
  }

  const selectedType = ref(POPULATION_TYPE.ALL);

  const selectedEntityType = ref([
    entitiesType.find((t) => t.id === POPULATION_TYPE.ALL),
  ]);

  const onEntityTypeChanged = (items: IconAndTextItemType[]) => {
    selectedType.value = items[0].id as POPULATION_TYPE;
    selectedEntityType.value = items;
    onChange(selectedEntityType.value[0] as IconAndTextItemType);
  };

  return {
    entitiesType,
    onEntityTypeChanged,
    selectedEntityType,
    selectedType,
  };
};
